import { useMemo } from "react";

import type { IPro014CampaignItem } from "@/@types/campaign";
import { useGetPro014AllItemsQuery } from "@/services/campaign-pro014";

export const useCampaignItemGrades = (campaignCode: number): IPro014CampaignItem[] => {
  const { data } = useGetPro014AllItemsQuery(campaignCode);

  return useMemo(
    (): IPro014CampaignItem[] =>
      (data ?? []).filter(
        (item: IPro014CampaignItem) => item.isActive && item.grades.length > 0,
      ),
    [data],
  );
};
